"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ownerWindow = _interopRequireDefault(require("@mui/utils/ownerWindow"));
var _default = exports.default = _ownerWindow.default;